import {AbstractModel} from '../abstract-model';

export class PartnerBlockRule extends AbstractModel {
  id: number | null = null;
  name: string | null = null;
  subid: string | null = null;
  blockTraffic: boolean = true;
  redirectUrl: string | null = null

  override toString(): string {
    return this.name ?? '';
  }
}
